import React from 'react';
import Moment from 'react-moment';
import { Label, Button, Tooltip, OverlayTrigger } from 'react-bootstrap';
import Loading from '../Loading.js';
import ResponsiveTable from '../Table/ResponsiveTable.js';
import { Glyphicon } from 'react-bootstrap';
import Form from "react-jsonschema-form";
import axios from 'axios';
import SpinningGlyhicon from '../SpinningGlyhicon.js';
import _ from 'lodash';

class JobsTable extends React.Component {
    constructor(props) {
        super(props)
        this.state = {          
            fething: false,
            fetched: false            
        }
        this.onSubmit = this.onSubmit.bind(this);
    }
    
onSubmit(form, job){    
    var _this = this;
    this.setState({
      fething: true,
      fetched: false
    });
   
    var input = form.formData;        
    var data = {
      token: this.props.user.token,
      input: Object.assign({}, input, job.input)
    }
    
    axios.post(this.props.configuration.dataAnalysis.url + "/jobs/" + job._id + "/resume", data)
      .then(function (response) {
        _this.setState({
          fething: false,
          fetched: true
        });
        _this.props.loadJobs(_this.props.user.username);
      })
      .catch(function (error) {
        _this.setState({
          fething: false,
          fetched: false
        });
               
      });
};

getColumns() {

    return [{
            text: 'id',
            dataField: '_id',
            hidden: true
        },
        {
            text: 'Type',
            dataField: 'type',
            responsiveHeaderStyle: {
                xs: { hidden: false }, sm: { hidden: false }, md: { hidden: false }, lg: { hidden: false }
            }
        },
        {
            text: 'Status',
            dataField: 'status',
            formatter: (cell, row, rowIndex, extraData) => <Status status={row.status} id={row.id} />,
            responsiveHeaderStyle: {
                xs: { hidden: false }, sm: { hidden: false }, md: { hidden: false }, lg: { hidden: false}
            }
        },
        {
            text: 'Description',
            dataField: 'input.description',
            responsiveHeaderStyle: {
                xs: { hidden: false }, sm: {hidden: false},md: {hidden: false,width: '50%'},
                lg: { hidden: false, width: '50%'}
            }
        },
        {
            text: 'Created',
            dataField: 'createdAt',
            formatter : (cell, row, rowIndex, extraData) => { return <Moment parse = 'YYYY-MM-DDTHH:mm:ssZ'  format = 'DD/MM/YYYY hh:mm' >${cell}</Moment>;},
            responsiveHeaderStyle: {
                xs: { hidden: false }, sm: { hidden: false}, md: { hidden: false}, lg: { hidden: false}
            }
        },
        {
            dataField: 'actions',
            text: 'Actions',
            isDummyField: true,
            csvExport: false,
            formatter: (cell, row, rowIndex, extraData) => <ActionsFormatter jobId={row._id} configuration={this.props.configuration} loadJobs={this.props.loadJobs} username={this.props.user.username} id={row.id} />
          }
       

    ];
}

render() {    
        if (this.props.fetching || this.state.fetching) {
            return <Loading message = 'Loading jobs' /> ;
        }  
     
        const expandRow = {
            showExpandColumn: true,            
            expanded: this.props.expanded,
            expandColumnPosition: 'right',
            expandByColumnOnly: true,
            expandHeaderColumnRenderer: ({ isAnyExpands }) => {
            if (isAnyExpands) {
                return <span style={{ fontSize: '18px' }}><Glyphicon glyph="zoom-out" /></span>;
            }
            return <span style={{ fontSize: '18px' }}><Glyphicon glyph="zoom-in" /></span>;
            },
            expandColumnRenderer: ({ expanded }) => {
            if (expanded) {
                return (
                <Glyphicon glyph="zoom-out" />
                );
            }
            return (
                <Glyphicon glyph="zoom-in" />
            );
        },

      

        renderer: job => {    
          if (job.onHold.length > 0){               
            var onHoldForm = job.onHold[job.onHold.length - 1];
            return <Form uiSchema={onHoldForm.uiSchema} formData={onHoldForm.formdata} schema={onHoldForm.schema} onSubmit={ (form) => this.onSubmit(form, job)} ></Form>;
          }
          return "No input required";
          
        }
      };

      

        return  <div>            
            <ResponsiveTable expandRow={expandRow} pageOptions={{sizePerPage:100}} search={false} keyField = '_id'  data = {_.filter(this.props.jobs, function(o) { return o.status !=="REMOVED"; } )}  columns = {this.getColumns()}/>        
        </div>;
    
    }
}

export default JobsTable;

class ActionsFormatter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {fetching: false, fetched : false};
            
        this.handleClick = this.handleClick.bind(this);
      }
      
      handleClick(status) {
     
        var _this = this;
        this.setState({
          fething: true,
          fetched: false
        });
       
               
        axios.get(this.props.configuration.dataAnalysis.url + "/jobs/" + this.props.jobId + "/status/" + status)
          .then(function (response) {
            _this.setState({
              fething: false,
              fetched: true
            });            
            _this.props.loadJobs(_this.props.username);
          })
          .catch(function (error) {
            _this.setState({
              fething: false,
              fetched: false
            });
                   
          });
      }
    render(){
        const tooltip = (
            <Tooltip id="tooltip">
              <strong>Abort</strong> this job
            </Tooltip>               
          );
          const removeTooltip = (
            <Tooltip id="tooltip">
              <strong>Remove</strong> this job
            </Tooltip>               
          );
          
        if (this.state.fetching){
            return 
        }
        return <div> 
                        <OverlayTrigger placement="left" overlay={tooltip}>
                            <Button onClick={() => this.handleClick("abort")} bsStyle="warning"  bsSize="small"><Glyphicon glyph="remove-sign" style={{marginRight:'5px'}}/>Abort</Button>
                        </OverlayTrigger>    
                        <OverlayTrigger placement="left" overlay={removeTooltip}>
                            <Button onClick={() =>this.handleClick("removed")} bsStyle="danger" style={{marginLeft:'5px'}}  bsSize="small"><Glyphicon glyph="trash" style={{marginRight:'5px'}}/>Delete</Button>
                        </OverlayTrigger>    
        
        </div>;

    }
}

class Status extends React.Component {
    render(){
        if (this.props.status === "ABORT"){
            return <Label bsStyle="warning"> <strong>{this.props.status}</strong></Label>;
        }
        
        if (this.props.status === "PENDING"){
            return <Label bsStyle="primary"> <strong>{this.props.status}</strong></Label>;
        }
        if (this.props.status === "RUNNING"){
            return <SpinningGlyhicon fetching={this.props.status == "RUNNING"} title={this.props.status}></SpinningGlyhicon>
        }

        if (this.props.status === "ONHOLD"){
            return <Label bsStyle="danger"> <strong>{this.props.status}</strong></Label>;
        }
        return <Label bsStyle="default"> <strong>{this.props.status}</strong></Label>;
    }
}


// WEBPACK FOOTER //
// ./src/components/Session/JobsTable.js